mod.modules.define("MyNotes", "BaseModule", function (fn) {

    var minHeight = 600;

    var cache = {
        $widget: null,
        $content: null,
        $list: null,
        $edit: null,
        $view: null,
        $editTitle: null,
        $editBody: null
    };

    fn.prototype.init = function (params) {
        this.base("init", params);

        // Cache
        cache.$widget = this.el;
        cache.$content = this.el.find("div.module-content-spacing");
        cache.$list = cache.$content.find(".mynotes-section[data-section='list']");
        cache.$edit = cache.$content.find(".mynotes-section[data-section='edit']");
        cache.$view = cache.$content.find(".mynotes-section[data-section='view']");
        cache.$editTitle = cache.$edit.find("input");
        cache.$editBody = cache.$edit.find("textarea");

        this.issueId = cache.$content.attr("data-issueId");

        // Add the page if it's necessary
        if (this.el.find("div.pager-wrap").length) {
            this.addPlugin("Plugin-Paging");
        }

        this.limitContentSize();
        this.matchColumnHeight();
    };

    fn.prototype.limitContentSize = function () {
        var $content = this.el.find("ul.mynotes-noteslist a span.text-bold");

        if ($content.length) {
            // Shrink the titles down if necessary
            $content.dotdotdot({
                height: 35,
                tolerance: 0,
                wrap: 'letter'
            });
        }
    };

    fn.prototype.matchColumnHeight = function () {
        var col1 = this.el.find("div.column-1");
        var col2 = this.el.find("div.column-2");

        if (col1.length && col2.length) {
            var col1Height = col1.height();
            var newHeight = Math.max(col1Height, minHeight);

            col2.height(newHeight);
        }
    };

    fn.prototype.handleNewNote = function ($el) {
        if ($el.attr("data-notecount") >= 10) {
            alert("A maximum of 10 notes are allowed per company.");
        }
        else {
            this.reload({
                EditedNote: null,
                ActionType: "edit"
            });
        }
    };

    fn.prototype.handleEditNote = function () {
        var editNote = this.getContext().EditedNote;

        this.reload({
            EditedNote: editNote,
            ActionType: "edit"
        });
    };

    fn.prototype.handleSaveNote = function () {
        var title = cache.$editTitle.val();
        var body = cache.$editBody.val();

        if (!title) {
        	cache.$editTitle.triggerHandler("focus");
            alert("Please enter a title for your note.");
        }
        else {
            this.reload({
                EditedNote: {
                    Title: title,
                    Body: body
                },
                ActionType: "save"
            });

            mod.observer.trigger("my notepad updated");
        }
    };

    fn.prototype.handleDeleteNote = function () {
        var deletedNote = this.getContext().EditedNote;
        deletedNote.IsDeleted = true;

        this.reload({
            EditedNote: deletedNote,
            ActionType: "save"
        });

        mod.observer.trigger("my notepad updated");
    };

    fn.prototype.handleCancelNote = function () {
        this.reload({
            //EditedNote: null,
            ActionType: "list"
        });
    };

    // Counts the characters in a text box and updates the designated character counter field
    fn.prototype.textCounter = function (e, $input) {
        var $counter = $input.siblings("div.input-character-count-label").find("span");
        $counter.text($input.val().length);
    }

    fn.prototype.events = {
        "button[data-action=new]": {
            "click": function (e, $el) {
                this.handleNewNote($el);
            }
        },
        "button[data-action=edit]": {
            "click": function (e, $el) {
                this.handleEditNote($el);
            }
        },
        "button[data-action=save]": {
            "click": function (e, $el) {
                this.handleSaveNote($el);
            }
        },
        "button[data-action=delete]": {
            "click": function (e, $el) {
                this.handleDeleteNote($el);
            }
        },
        "button[data-action=cancel], button[data-action=all]": {
            "click": function (e, $el) {
                this.handleCancelNote($el);
            }
        },
        "input[maxlength], textarea[maxlength]": {
            "keyup": function (e, $el) {
                this.textCounter(e, $el);
            }
        },
        "a[data-note]": {
            "click": function (e, $el) {
                var noteJson = $el.attr("data-note");
                var noteObj = JSON.parse(noteJson);

                this.reload({
                    EditedNote: noteObj,
                    ActionType: "view"
                });
            }
        }
    };

});